<div class="width-container">

  <div class="flex justify-content-center wrapper bg-search">
    <div class="wrapper-content lg:gap-2 xl:gap-4 xl:mx-0 sm:mx-3">
      <section class="content-main f-70">
        <h1 class="title-section title-blue my-2 text-uppercase hidden md:block" >{{'components.app-consulta-tramites.consulta-de-trámites'| translate}}</h1>
        <span class="subtitle-section app-text-gray my-2  hidden md:block">{{'components.app-consulta-tramites.subtitle-consulta-de-trámites'| translate}}:</span>
        <section class="search-bar mt-2 ">
          <div class="sm:hidden flex flex-column">
            <h2 class="title-section title-blue my-2 text-uppercase">
              {{ 'components.app-sede-electronica-tramites.consulta-tramites' | translate }}
            </h2>
            <p class="subtitle-section app-text-gray my-1">
              {{ 'components.app-sede-electronica-tramites.descripcion-consulta-tramites' | translate }}:
            </p>
            <div class="mt-5">
              <label for="dependencia" class="font-15 font-principal app-text-gray font-normal">
                {{ 'components.app-sede-electronica-tramites.label-dependecias' | translate }}:
              </label>
              <p-multiSelect [options]="dependencies" optionLabel="descripcion" class="mt-2"
                             [placeholder]="'components.app-consulta-tramites.dependencias' | translate"
                             [(ngModel)]="dependenciesSelected" styleClass="md:border-none
                             border-gradient content-border container-input-rounded mt-2 mb-3"
                             [filter]="true"></p-multiSelect>
            </div>
            <div class="mt-3">
              <label for="search" class="font-15 font-principal font-normal app-text-gray">
                {{ 'components.app-sede-electronica-tramites.label-tramite' | translate }}:
              </label>
              <div class="border-gradient p-0 container-input-rounded content-border mt-2">
                <input type="text" pInputText [(ngModel)]="tramiteSearch"
                       class="w-full border-0 border-round-3xl ml-3 font-medium "
                       (keydown.enter)="search()" aria-label="Search"
                       [placeholder]="'components.app-sede-electronica-tramites.placeholder-tramite'| translate"/>
              </div>
            </div>
            <div class="flex justify-content-center mt-5">
              <button pButton (click)="search()" class="p-button-rounded btn-blue-general flex
                   w-19rem align-items-center justify-content-center">
                  <span class="text-white mr-2 font-18">
                    {{ 'components.app-sede-electronica-tramites.consulta-tramites' | translate }}
                  </span>
                    <img alt="search icon" ngSrc="assets/img/svg/gov-ico-search.svg"
                         priority draggable="false" width="20" height="20">
              </button>
            </div>
          </div>
          <div class=" container-input-rounded container-input border-none sm:border-3
          border-gradient hidden md:flex content-border p-0">
            <div class="input-text border-gradient sm:border-none border-3 align-items-center flex flex-column sm:flex-row ">
              <img class="icon" alt="icon search" ngSrc="assets/img/icons-principal/ico-search.svg"
                   priority draggable="false" width="36" height="36">
              <input type="text" pInputText [(ngModel)]="tramiteSearch" class="w-full font-16 font-medium"
                     (keydown.enter)="search()"
                     [placeholder]="'components.app-consulta-tramites.placeholder'| translate"/>
            </div>

            <p-multiSelect [options]="dependencies" optionLabel="descripcion"  class="mr-2 lg:w-3 max-w-19rem"
                           [placeholder]="'components.app-consulta-tramites.dependencias' | translate"
                           [maxSelectedLabels]="2" [(ngModel)]="dependenciesSelected"  styleClass="md:border-none h-full"
                           [filter]="true"></p-multiSelect>
            <button pButton type="submit"
                    class="search sm:py-2 md:px-3 flex" (click)="search()">
              <span class="text-white font-18">{{'form.button.buscar' | translate}}</span>
            </button>
          </div>
          <div class="hidden md:block">
            <div class="field col-12 flex  flex-column align-items-center">
              <div class="flex align-self-stretch justify-content-end flex-wrap">
                <div>
                  <a class="text-blue-general underline">Ver lista completa de
                    Trámites. </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <article class="f-30 hidden lg:flex flex-column">
        <div class="mb-2">
          <h1 class="title-section title-blue my-2 text-uppercase" >{{'components.app-consulta-tramites.ver-estado-tramites' | translate}}</h1>
          <span class="subtitle-section app-text-gray my-2">{{'components.app-consulta-tramites.subtitle-estado-tramites' | translate}}:</span>
        </div>

        <div class=" container-input-rounded border-outline-blue-light bg-white">
          <div class="input-text flex align-items-center">
            <div class="border-circle container-icon ">
              <span class="title-blue">#</span>
            </div>
            <input type="text" pInputText [(ngModel)]="radicado" [style]="{'width':'100%'}" (keydown.enter)="searchRadicado()"
                   [placeholder]="'components.app-consulta-tramites.placeholder-radicado'| translate"/>
          </div>

          <button pButton (click)="searchRadicado()"  class="bg-blue-light">
            <span class="text-white">{{'form.button.ver' | translate}}</span>
          </button>
        </div>
      </article>
    </div>
  </div>
  <div class="wrapper-content md:mt-0 mt-4 xl:mx-auto sm:mx-3 sm:w-auto flex-column px-0 sm:px-auto
 lg:flex-row lg:w-full xl:gap-4 lg:gap-2">
    <app-resultados-busqueda typeContent="list" class="f-70"/>

    <div class="f-30 mb-2 hidden flex-column gap-4 md:flex">
      <app-aside-public class="pt-2"/>
    </div>
  </div>




</div>

